// @flow
/** @jsx jsx */

import { paddingToCss } from '@zapier/common-utils';
import { css, jsx } from '@emotion/core';

import type { Node } from 'react';
import type { Spacing } from '@zapier/common-utils';

type Width = 'narrow' | 'normal' | 'wide';
type Widths = { [Width]: number | 'none' };

const widths: Widths = {
  narrow: 1000,
  normal: 1120,
  wide: 'none',
};

type PageSectionProps = {
  className?: string,
  /** Content to be wrapped */
  children?: Node,
  id?: string,
  padding?: Spacing,
  width?: Width,
};

const sectionStyle = ({ width, padding }: PageSectionProps) =>
  css({
    ...paddingToCss(padding, '20px'),
    margin: '0 auto',
    maxWidth: widths[width || 'normal'],
  });

const PageSection = (props: PageSectionProps) => {
  return (
    <section
      className={props.className}
      css={sectionStyle(props)}
      id={props.id}
    >
      {props.children}
    </section>
  );
};

export default PageSection;
